import React, { createContext, useContext, useEffect, useState } from 'react';

const WishlistContext = createContext(null);
const STORAGE_KEY = 'oh:wishlist:v1';

function read() {
  try { const r = localStorage.getItem(STORAGE_KEY); return r ? JSON.parse(r) : []; }
  catch (_) { return []; }
}
function write(items) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (_) {}
}

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => read());
  useEffect(() => { write(items); }, [items]);
  useEffect(() => {
    const onStorage = (e) => { if (e.key === STORAGE_KEY) setItems(read()); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const has = (id) => items.some((it) => String(it.id) === String(id));
  const toggle = (product) => {
    if (!product?.id) return;
    setItems((cur) => {
      if (cur.some((it) => String(it.id) === String(product.id))) {
        return cur.filter((it) => String(it.id) !== String(product.id));
      }
      return [...cur, {
        id: product.id,
        name: product.name,
        brand: product.brand || '',
        price: typeof product.price === 'number' ? product.price : 0,
        image: product.image || product.image_url || '',
      }];
    });
  };
  const remove = (id) => setItems((cur) => cur.filter((it) => String(it.id) !== String(id)));
  const clear = () => setItems([]);

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, clear, totalCount: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used inside <WishlistProvider>');
  return ctx;
}
